export enum SelfPayVisitType {
  TELEHEALTH = 'telehealth',
  OFFICE = 'office'
}

export enum SelfPayRateType {
  TALK_THERAPY_INTAKE = 'talk_therapy_intake',
  TALK_THERAPY_FOLLOW_UP = 'talk_therapy_follow_up',
  PSYCHIATRY_INTAKE = 'psychiatry_intake',
  PSYCHIATRY_FOLLOW_UP = 'psychiatry_follow_up',
  PSYCHIATRY_FOLLOW_UP_ADD_ON = 'psychiatry_follow_up_add_on'
}

export interface ISelfPayRateItem {
  licensureGroup: string;
  cptCode: string;
  type: SelfPayRateType;
  amount: {
    amount: number;
    amountS: string;
  };
}
